import { combineReducers } from '@ngrx/store';

import { globalUiFiltersByResultsReducer as filters } from '@app/store/reducers/globalUi/results/filters';
import {
  isLoadingResultsReducer as isLoadingResults
} from '@app/store/reducers/globalUi/results/is-loading-results.reducer';
import {
  isLoadingResultsDetailReducer as isLoadingResultsDetail
} from '@app/store/reducers/globalUi/results/is-loading-results-detail.reducer';

export const globalUiResultsReducer = combineReducers({
  filters,
  isLoadingResults,
  isLoadingResultsDetail,
});
